// Copyright (c) 2020 Deere & Company

import actions from '../actions-list';

const defaultValue = 0;

const decreaseBusyCounter = state => state > 0 ? state - 1 : 0;

const increaseBusyCounter = state => state + 1;

const resetBusyCounter = () => 0;

export default ( state = defaultValue, action ) => {

    const actionTypes = {
        [actions.DECREASE_BUSY_COUNTER]: decreaseBusyCounter,
        [actions.INCREASE_BUSY_COUNTER]: increaseBusyCounter,
        [actions.RESET_BUSY_COUNTER]: resetBusyCounter
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer( state, action ) :
        state;

};
